import type { BaremetalServer } from '@/entities/baremetal';
import request from '@/shared/api/request';

export const getServer = (id: number): Promise<{ baremetal: BaremetalServer }> =>
  request({
    url: `/baremetals/${id}/`,
  });
